export const breakpoints = {
  small: `767.9px`,
  medium: `920.9px`,
  large: `1400px`,
};
